import _mixin from '../_mixin'

export default {
  name: 'SVersionRank',
  cnName: '充值排行榜类',
  type: 'activity_version',
  preview: 'https://rescdn-crash.ssjj.cn/website/2023/03/30/dc3e42f445c1787417e8e090fd2b9591.jpeg',
  // 属性相关
  props: {
    keyword: "test_keyword",
    defaultBg: {
      src: 'https://rescdn-crash.ssjj.cn/website/2025/07/16/3741729c1293328e98ae185a279aa39d.jpg',
      style: {
        width: '1920px',
        height: '2278px'
      }
    },
    selfRechargeStyle: {
      style: {
        position: 'absolute',
        top: '350px',
        right: '',
        bottom: '',
        left: '700px'
      }
    },
    selfRankStyle: {
      style: {
        position: 'absolute',
        top: '350px',
        right: '',
        bottom: '',
        left: '1250px'
      }
    },
    btnNameList: [
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '256px' },
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '566px' },
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '877px' },
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '1187px' },
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '1497px' },
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '256px' },
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '566px' },
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '877px' },
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '1187px' },
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '1497px' }
    ],
    btnRankList: [
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '256px' },
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '566px' },
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '877px' },
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '1187px' },
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '1497px' },
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '256px' },
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '566px' },
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '877px' },
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '1187px' },
      { position: 'absolute', top: '', right: '', bottom: '90px', left: '1497px' }
    ],
    nameTextStyle: '{"color": "#FFFFFF", "fontSize": "24px"}',
    valueTextStyle: '{"color": "#FFD700", "fontSize": "20px"}',
    totalTextStyle: '{"color": "#FFFFFF", "fontSize": "18px"}'
  },
  propsDesc: [
    {
      target: 'keyword',
      label: '排行榜唯一标识'
    },
    {
      target: 'defaultBg',
      label: '底图',
      formType: 'image'
    },
    {
      target: 'selfRechargeStyle',
      label: '自己累积进度(不需要配置连接)',
      formType: 'image'
    },
    {
      target: 'selfRankStyle',
      label: '自己排名(不需要配置连接)',
      formType: 'image'
    },
    {
      target: 'btnNameList',
      label: '名称定位',
      formType: 'list',
      listConfig: [
        {
          title: '定位',
          target: 'position'
        },
        {
          title: '上',
          target: 'top'
        },
        {
          title: '右',
          target: 'right'
        },
        {
          title: '下',
          target: 'bottom'
        },
        {
          title: '左',
          target: 'left'
        }
      ]
    },
    {
      target: 'btnRankList',
      label: '排名定位',
      formType: 'list',
      listConfig: [
        {
          title: '定位',
          target: 'position'
        },
        {
          title: '上',
          target: 'top'
        },
        {
          title: '右',
          target: 'right'
        },
        {
          title: '下',
          target: 'bottom'
        },
        {
          title: '左',
          target: 'left'
        }
      ]
    },
    {
      target: 'nameTextStyle',
      label: '前三名名字样式'
    },
    {
      target: 'valueTextStyle',
      label: '前三名海里样式'
    },
    {
      target: 'totalTextStyle',
      label: '4-10名名称海里样式'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ]
}
